import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ServiceAreasServiceType} from "../../../service-areas/angular/types/service-areas-service.type";
import {GroupModel} from "../../../groups/models/group.model";

export class BringozMultiSelectFilterPanelComponent implements IController {

  queryMap: any;
  type: any;
  panelRef: any;
  selectedIds: any;
  billingAccountIds: any;
  options: any;
  optionsWrapper?: { list?: any[], propertyRef: string };
  optionIds: any;
  selectParams: any;
  serviceAreasTypes: ServiceAreasServiceType[];
  ngPlaceholder: any;
  noUnderline: any;
  excludeIds: any;
  isOrderedOptions: boolean;
  optionsPrefix: string;
  accountIds: string[];
  selectSettings: any;
  isAllowExcludeMode: boolean;
  isExcludeMode: boolean;
  hideGroupsFilter: boolean;
  hideTagsFilter: boolean;

  private selectedIdsCopy: any;
  private isExcludeModeCopy: any;
  public branchGroups: GroupModel[];
  public groupBranchIds: string[];

  $onInit() {
    if (this.selectedIds) {
      this.selectedIdsCopy = angular.copy(this.selectedIds);
    }

    this.selectSettings = this.selectSettings || {};
    if (this.hideGroupsFilter !== undefined) {
      this.selectSettings.hideGroupsFilter = this.hideGroupsFilter;
    }
    if (this.hideTagsFilter !== undefined) {
      this.selectSettings.hideTagsFilter = this.hideTagsFilter;
    }

    this.isExcludeModeCopy = this.isExcludeMode;
  }

  onSelectMultiValues(ids) {
    this.selectedIdsCopy = angular.copy(ids);
  }

  onToggleExcludeMode(isExcludeMode: boolean) {
    this.isExcludeModeCopy = isExcludeMode;
  }

  onSubmit() {
    this.panelRef.config.onCloseSuccess(this.panelRef, this.selectedIdsCopy, this.isExcludeModeCopy);
  }

  onSubmitAll() {
    const selectedIds = this.optionIds || _.map(this.options, 'id')
    this.panelRef.config.onCloseSuccess(this.panelRef, selectedIds);
  }

  onReset() {
    // const ids = this.excludeIds || [];
    this.panelRef.config.onCloseSuccess(this.panelRef, undefined, false);
  }

  onCancel() {
    this.panelRef.config.onCloseSuccess(this.panelRef, this.selectedIds, this.isExcludeMode);
  }

  onChangeFilterGroups(groups) {
    this.branchGroups = groups;
    this.groupBranchIds = [];
    groups?.forEach((g: GroupModel) => {
      if (g.branchIds?.length) {
        this.groupBranchIds = _.uniq(this.groupBranchIds.concat(g.branchIds));
      }
    });
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozMultiSelectFilterPanel', {
    bindings: {
      type: '<',
      queryMap: '<?',
      panelRef: '<',
      selectedIds: '<?',
      options: '<?',
      optionsWrapper: '<?',
      optionIds: '<?',
      billingAccountIds: '<?',
      selectParams: '<?',
      accountIds: '<?',
      depotIds: '<?',
      serviceAreasTypes: '<?',
      ngPlaceholder: '<?',
      hideGroupsFilter : '<?',
      hideTagsFilter: '<?',
      canSelectAll: '<?',
      excludeIds: '<?',
      isOrderedOptions: '<?',
      selectSettings: '<?',
      isAllowExcludeMode: '<?',
      isExcludeMode: '<?',
      optionsPrefix: '@?'
    },
    template: require('./bringoz-multi-select-filter-panel.html').default,
    controller: BringozMultiSelectFilterPanelComponent
  });
